export const DEFAULT_PUBLISH_PAGE_SIZE = 50;

export const PUBLISH_STAGES = ['sales', 'mis', 'accounts', 'all'] as const;
export type PublishStage = (typeof PUBLISH_STAGES)[number];

export const PUBLISH_PANEL_PATH = {
  sales: '/publish/sales',
  mis: '/publish/mis',
  accounts: '/publish/accounts',
} as const;

export const PUBLISH_PANEL_PATHS = [
  PUBLISH_PANEL_PATH.sales,
  PUBLISH_PANEL_PATH.mis,
  PUBLISH_PANEL_PATH.accounts,
] as const;
